import { gql } from '@apollo/client';

export const GET_ALL_CUSTOMERS = gql`
  query GetAllCustomers($limit: Int, $offset: Int) {
    getAllCustomers(input: { limit: $limit, offset: $offset }) {
      statusCode
      message
      total
      limit
      offset
      customers {
        id
        email
        name
        ironcustomerid
        status
        isNoLimit
        # Accreditation letter / ACE credential / admin review, for the Approve/Deny column.
        accreditationLetterStatus
        accreditationAceStatus
        accreditationReviewStatus
        wallets {
          id
          chain
          walletAddress
          isActive
        }
        createdat
        updatedat
      }
    }
  }
`;
